import { render, staticRenderFns } from "./VerifikasiPasca.vue?vue&type=template&id=899ce788&scoped=true&"
import script from "./VerifikasiPasca.vue?vue&type=script&lang=js&"
export * from "./VerifikasiPasca.vue?vue&type=script&lang=js&"
import style0 from "./VerifikasiPasca.vue?vue&type=style&index=0&id=899ce788&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899ce788",
  null
  
)

export default component.exports